import React, { useState, useCallback } from "react";
import { UploadOutlined } from "@ant-design/icons";
import { Form, Button, Upload, Row, Col, message } from "antd";
import { connect } from "dva";
import { normalizeFile, fakeFileUpload } from "@/utils/form";

const UpdateBayLocationsForm = ({ formRef, setBayLocationModalVisible, dispatch }) => {
  const [fileList, setFileList] = useState([]);

  const handleChange = info => {
    let fileList = info.fileList;
    if (fileList.length > 1) {
      fileList = fileList.slice(1);
    }
    setFileList([...fileList]);
  };

  const onSubmit = useCallback(
    values => {
      dispatch({
        type: "wwlNissan/bulkUpdateBayLocations",
        payload: values.bayLocationFile[0].originFileObj,
      }).then(response => {
        if (!response?.error) {
          message.success("Successfully uploaded file.");
          setBayLocationModalVisible(false);
        }
      });
    },
    [dispatch, setBayLocationModalVisible],
  );

  return (
    <Form layout="vertical" form={formRef} onFinish={onSubmit}>
      <Row>
        <Col flex={1}>
          <Form.Item
            name="bayLocationFile"
            valuePropName="fileList"
            getValueFromEvent={event => normalizeFile(event, 1)}
            extra='Please select spreadsheet with vins and bay locations. Columns must be named "VIN" and "Bay Location". An email will be sent to nissangroup@autosled.com once the file has been processed.'
            rules={[
              {
                required: true,
                message: "Please select a file.",
              },
            ]}
          >
            <Upload
              name="Spreadsheet"
              accept=".xlsx, .csv, .xls"
              multiple={false}
              fileList={fileList}
              onChange={handleChange}
              customRequest={fakeFileUpload}
            >
              <Button icon={<UploadOutlined />}>Click to upload</Button>
            </Upload>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default connect(({ loading }) => ({
  uploadingBayLocationSpreadsheet: loading.effects["wwlNissan/bulkUpdateBayLocations"],
}))(UpdateBayLocationsForm);
